import {Component, ComponentFactoryResolver, Input, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {PAYMENT_TYPE} from './api/entity/constants';
import {FeeTransferIcon} from './icons/fee/fee.transfer.icon';
import {IncomingTransferIcon} from './icons/incoming/incoming.transfer.icon';
import {RefundTransferIcon} from './icons/refund/refund.transfer.icon';
import {DeliveredTransferIcon} from './icons/delivered/deivered.transfer.icon';

import {InternalExchangeTransferIcon} from './icons/internal/internal.exchnage.transfer.icon';
import {SystemExchangeTransferIcon} from './icons/system/system.exchange.transfer.icon';
import {SystemTransferIcon} from './icons/system/system.transfer.icon';
import {Incoming4TransferIcon} from './icons/incoming/incoming.4.transfer.icon';
import {UndeliveredTransferIcon} from './icons/undelivered/undelivered.transfer.icon';
import {Outgoing4TransferIcon} from './icons/outgoing/outgoing.4.transfer.icon';
import {Outgoing3TransferIcon} from './icons/outgoing/outgoing.3.transter.icon';
import {OutgoingTransferIcon} from './icons/outgoing/outgoing.transfer.icon';
import {InternalTransferIcon} from './icons/internal/internal.transfer.icon';
import {CardExchangeTransferIcon} from './icons/card/card.exchange.transfer.icon';
import {CardTransferIcon} from './icons/card/card.transfer.icon';
import {OutgoingExchangeTransferIcon} from './icons/outgoing/outgoing.exchange.transfer.icon';
import {TransferIconModel} from './api/entity/transfer/transfer.icon.model.i';


@Component({
    selector: 'tfl-transfer-icon-factory',
    template: '<div #icon></div>'
})
export class TransferIconFactory {

    @Input('transfer') transfer: TransferIconModel;
    @ViewChild('icon', {read: ViewContainerRef}) icon: ViewContainerRef;

    constructor(private _componentFactory: ComponentFactoryResolver) {
    }

    ngAfterViewInit() {
        this.createIconComponent(this.getIconComponent());
    }

    get type(): PAYMENT_TYPE {
        return this.transfer.type;
    }

    get isExchange(): boolean {
        return this.transfer.exchange;
    }

    private mainTypeIs(type: PAYMENT_TYPE): boolean {
        return this.transfer.main_type === type;
    }

    private getIconComponent(): Type<any> {
        switch (this.type) {
            case PAYMENT_TYPE.FEE:
                return FeeTransferIcon;

            case PAYMENT_TYPE.INCOMING:
                return IncomingTransferIcon;

            case PAYMENT_TYPE.REFUND:
                return RefundTransferIcon;

            case PAYMENT_TYPE.DELIVERED:
                return DeliveredTransferIcon;

            case PAYMENT_TYPE.INTERNAL:
                return this.isExchange
                    ? InternalExchangeTransferIcon
                    : InternalTransferIcon;

            case PAYMENT_TYPE.CARD:
                return this.isExchange
                    ? CardExchangeTransferIcon
                    : CardTransferIcon;

            case PAYMENT_TYPE.SYSTEM:
                return this.isExchange
                    ? SystemExchangeTransferIcon
                    : SystemTransferIcon;

            case PAYMENT_TYPE.UNDELIVERED:
                return this.mainTypeIs(PAYMENT_TYPE.DELIVERED)
                    ? Incoming4TransferIcon
                    : UndeliveredTransferIcon;


            case PAYMENT_TYPE.OUTGOING:
                if (this.isExchange && this.mainTypeIs(PAYMENT_TYPE.REFUND)) {
                    return Outgoing4TransferIcon;
                } else if (this.isExchange) {
                    return OutgoingExchangeTransferIcon;
                } else if (this.mainTypeIs(PAYMENT_TYPE.REFUND)) {
                    return Outgoing3TransferIcon;
                } else {
                    return OutgoingTransferIcon;
                }
        }
    }

    private createIconComponent(component: Type<any>) {
        if (!!component) {
            const factory = this._componentFactory.resolveComponentFactory(component);
            this.icon.createComponent(factory, 0).changeDetectorRef.detectChanges();
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/transfer.icon.factory.ts